import { z } from "zod";
import type { PublicEventTerms } from "./events.js";
import { SECTOR_IDS } from "./world-layout.js";
import type { StationDefinition } from "./stations.js";
import {
  captureStationTruceTerms,
  stationTruceTermsSchema,
} from "./station-truce.js";

export const truceEventTermsSchema = z
  .strictObject({
    type: z.literal("truce"),
    title: z.string().min(1).max(500),
    description: z.string().min(1).max(500),
    sectorId: z.enum(SECTOR_IDS),
    x: z.number().finite().nonnegative(),
    y: z.number().finite().nonnegative(),
    duration: z.literal(0),
    credits: z.literal("100"),
    components: z.literal(3),
    blueprintUnlocks: z.array(z.never()).length(0),
    version: z.literal("public-events-v4"),
    variantId: z.literal("station-truce-v1"),
    condition: z.string().min(1).max(500),
    salvage: z.null(),
    truce: z.strictObject({
      criminalId: z.string().min(1).max(100),
      rules: stationTruceTermsSchema,
    }),
  })
  .refine(
    (terms) =>
      terms.sectorId === terms.truce.rules.station.sectorId &&
      terms.x === terms.truce.rules.station.x &&
      terms.y === terms.truce.rules.station.y,
    { message: "The hunt origin must match its frozen station" },
  ) satisfies z.ZodType<PublicEventTerms>;

/** A real murder supplies the target; scheduled event creation cannot start a hunt. */
export function createTruceEventTerms(
  station: StationDefinition,
  criminalId: string,
): PublicEventTerms {
  const rules = captureStationTruceTerms(station);
  return truceEventTermsSchema.parse({
    type: "truce",
    title: `Сигнал охраны «${station.name}»`,
    description:
      "В зоне станции убит пилот. Останови нарушителя, пока он не скрылся.",
    sectorId: rules.station.sectorId,
    x: rules.station.x,
    y: rules.station.y,
    duration: 0,
    credits: rules.credits,
    components: rules.components,
    blueprintUnlocks: [],
    version: "public-events-v4",
    variantId: "station-truce-v1",
    condition:
      "Нанеси урон нарушителю или помоги защитнику ремонтом. Выход нарушителя из сектора завершает охоту.",
    salvage: null,
    truce: { criminalId, rules },
  });
}
